module.exports = __webpack_public_path__ + "static/011.thumb-16328c328f782c2048a71ec84538ee6e.jpg";